import cn from 'classnames';
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';
import type { InputProps } from '../../../../../components/design/Input/Input';
import { Input } from '../../../../../components/design/Input/Input';

export type QuantityInputProps = {
  defaultValue: number;
};

const QuantityInput = forwardRef(
  (props: InputProps<QuantityInputProps>, ref: ForwardedRef<HTMLInputElement>) => {
    return (
      <Input
        {...{
          ...props,
          ref,
          type: 'number',
          debounce: false,
          step: 'any',
          selectOnFocus: true,
          className: cn(
            'placeholder:text-placeholder py-3.5 w-full bg-transparent rounded text-center border-none bg-white',
          ),
        }}
      />
    );
  },
);

export default QuantityInput;
